// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import AlertError from "@steiner/XDL/Icons/AlertError";
import AlertInfo from "@steiner/XDL/Icons/AlertInfo";
import AlertSuccess from "@steiner/XDL/Icons/AlertSuccess";
import AlertWarning from "@steiner/XDL/Icons/AlertWarning";
import { buttonTransparent } from "@steiner/XDL/PreStyle/button";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                margin-right: 10px;
                ${buttonTransparent}
                &:hover ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: "X",
            size: 14,
            color: "common.ui6",
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-right: 16px;
                margin-top: 2px;
                ${xScreen("lte", "xs")} {
                    margin-top: 3px;
                }
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                &,
                & > ${TypographyStyle}, & > div > ${TypographyStyle} {
                    font-size: 14px;
                    line-height: 22px;
                    ${xScreen("lte", "xs")} {
                        font-size: 12px;
                        line-height: 16px;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                justify-content: space-between;
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                    align-items: flex-start;
                }
                padding: 7px 9px;
                margin-top: 2px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
        mergeCss: true,
    },
} as xBaseTheme["toast"];
